import { zodResolver } from '@hookform/resolvers/zod';
import { useEffect } from 'react';
import { Mode, useForm } from 'react-hook-form';
import { IDraftJobPostEntity, IJobPostDetailEntity } from '~/domain/PermanentJobs';
import { JobDetailsFormMapper } from '../mappers/JobDetailsFormMapper';
import { jobDetailsSchema, TJobDetailsSchemas } from '../schema';
import { IJobDetailsForm } from '../Types';

interface IJobDetailsFormProps<T extends TJobDetailsSchemas> {
  initialValues?: IDraftJobPostEntity | IJobPostDetailEntity;
  schema?: T;
  mode?: Mode;
}

export const useJobDetailsForm = <T extends TJobDetailsSchemas>({
  initialValues,
  schema = jobDetailsSchema as T,
  mode = 'onSubmit',
}: IJobDetailsFormProps<T> = {}) => {
  const form = useForm<IJobDetailsForm>({
    mode,
    resolver: zodResolver(schema),
    defaultValues: JobDetailsFormMapper.fromEntity(initialValues),
  });

  const { watch, trigger, formState } = form;

  useEffect(() => {
    const subscription = watch((_, { name }) => {
      if (name && formState.errors[name as keyof IJobDetailsForm]) {
        trigger(name as keyof IJobDetailsForm);
      }
    });
    return () => subscription.unsubscribe();
  }, [watch, trigger, formState.errors]);

  return form;
};
